module.exports = __webpack_public_path__ + "static/media/S (27).cb73e9cc.jpg";